export enum InvoiceProcessingLevel {
  Group = 'group',
  Division = 'division',
  Line = 'line'
}

export const mapper: Record<InvoiceProcessingLevel, string> = {
  [InvoiceProcessingLevel.Group]: 'Group Level',
  [InvoiceProcessingLevel.Division]: 'Invoice Division Level',
  [InvoiceProcessingLevel.Line]: 'Invoice Line Level'
}
